/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import dayjsUtils from '@date-io/dayjs';
import Image from '../../../components/image';
import Label from '../../../components/label';
import Button from '../../../components/button';
import DateInput from './components/date-input';
import styles from './view.scss';

function View(props) {
  const { t, i18n, selectedDate, presenter, format, errorText } = props;
  const [showDatePicker, setShowDatePicker] = useState(false);

  return (
    <div className={clsx('age-landing-container', styles.container)}>
      <div className={clsx('age-landing-background-image-container', styles.imageContainer)}>
        <Image
          alt=""
          src={
            i18n.exists('age.landing.background_image.src')
              ? t('age.landing.background_image.src')
              : ''
          }
          className={clsx('age-landing-background-image', styles.image)}
        />
      </div>
      <div className={clsx('age-landing-inner-container', styles.innerContainer)}>
        <DateInput
          className={clsx('age-landing-date', errorText && 'error')}
          value=""
          helperText={errorText && t(errorText)}
          date={selectedDate}
          order={format}
          label={t('age.landing.input_label')}
          onClick={() => setShowDatePicker(true)}
        />
        <Button
          className={clsx('age-landing-button', styles.button)}
          text={t('age.landing.button_text')}
          onClick={() => presenter.onNextClick()}
        />
        <MuiPickersUtilsProvider utils={dayjsUtils}>
          <DatePicker
            open={showDatePicker}
            value={selectedDate}
            onChange={(date) => presenter.onBirthdayChange(date)}
            disableFuture
            openTo="year"
            format="DD MMMM YYYY"
            onAccept={(date) => presenter.onBirthdaySelected(date)}
            TextFieldComponent={() => <div />}
            onClose={() => setShowDatePicker(false)}
          />
        </MuiPickersUtilsProvider>
        <div className={clsx('age-landing-footer-space', styles.space)} />
        <Label
          className={clsx('age-landing-footer', styles.footer)}
          text={t('age.landing.footer')}
        />
      </div>
    </div>
  );
}

export default withTranslation()(View);
